import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {ResultRootState as RootState} from '../../interfaces'
import admissionDetail from '../../slices/admissionDetail'
import aitems from '../../slices/aitems'
import banner from '../../slices/banner'
import cashReceipt from '../../slices/cashReceipt'
import chargePoint from '../../slices/chargePoint'
import common from '../../slices/common'
import deliveryInfo from '../../slices/deliveryInfo'
import deliveryManager from '../../slices/deliveryManager'
import pointPayment from '../../slices/pointPayment'
import priorityPaymentMethod from '../../slices/priorityPaymentMethod'
import purchaser from '../../slices/purchaser'
import recommendationProduct from '../../slices/recommendationProduct'
import result from '../../slices/result'
import reward from '../../slices/reward'
import shoppingSubscription from '../../slices/shoppingSubscription'
import subscribe from '../../slices/subscribe'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        aitems,
        banner,
        cashReceipt,
        chargePoint,
        admissionDetail,
        common,
        deliveryInfo,
        deliveryManager,
        pointPayment,
        priorityPaymentMethod,
        purchaser,
        recommendationProduct,
        result,
        reward,
        router: routerReducer,
        shoppingSubscription,
        subscribe,
    })

export default createRootReducer
